<template>
  <im-right-content-layout :is-active="isActive" :border="isActive && imLeftActiveName === 'chat'">
    <template v-slot:im-right-content-header>
      <im-right-content-title :title="nickName" :channel="channel" />
      <im-right-content-header-more v-show="nickName" />
    </template>
    <chat-wrap v-show="isActive && imLeftActiveName === 'chat'" />
    <contact-wrap v-show="isActive && imLeftActiveName === 'mailList' && imActiveContactType === 'contact'" :im-active-contact="imActiveContact" />
    <team-wrap v-show="isActive && imLeftActiveName === 'mailList' && imActiveContactType === 'team'" :im-active-team="imActiveContact" />
  </im-right-content-layout>
</template>

<script>
import { mapState } from 'vuex'
import ImRightContentLayout from './ImRightContentLayout'
import ImRightContentTitle from './ImRightContentTitle'
import ImRightContentHeaderMore from './ImRightContentHeaderMore'
import ChatWrap from './ChatWrap'
import ContactWrap from './contacts/ContactWrap'
import TeamWrap from '../team/list/TeamWrap.vue'
export default {
  name: 'ImRightContent',
  components: {
    ImRightContentLayout,
    ImRightContentTitle,
    ChatWrap,
    ContactWrap,
    TeamWrap,
    ImRightContentHeaderMore
  },
  computed: {
    ...mapState({
      imLeftActiveName: state => state.imLeftActiveName,
      activeAccount: state => state.imActiveAccount,
      imActiveContact: state => state.imActiveContact,
      imUserProfiles: state => state.imUserProfiles,
      imActiveContactType: state => state.imActiveContactType,
      imTeams: state => state.imTeams
    }),
    isActive () {
      if (this.imLeftActiveName === 'chat') {
        return Object.keys(this.activeAccount).length !== 0 && this.activeAccount.constructor === Object
      }

      if (this.imLeftActiveName === 'mailList') {
        return Object.keys(this.imActiveContact).length !== 0 && this.imActiveContact.constructor === Object
      }
      return false
    },
    nickName () {
      console.log('imUserProfiles', this.imUserProfiles[this.activeAccount.to])
      if (this.imLeftActiveName === 'chat') {
        if (this.activeAccount.scene === 'p2p' || this.activeAccount.scene === 'bot') {
          return this.imUserProfiles[this.activeAccount.to] && this.imUserProfiles[this.activeAccount.to].nick ? this.imUserProfiles[this.activeAccount.to].nick : this.activeAccount.to
        } else {
          return this.imTeams[this.activeAccount.to] && this.imTeams[this.activeAccount.to].name ? this.imTeams[this.activeAccount.to].name + '（' + this.imTeams[this.activeAccount.to].memberNum + '）' : this.activeAccount.to
        }
      }
      return ''
    },
    channel () {
      if (this.imLeftActiveName === 'chat') {
        if (this.imUserProfiles[this.activeAccount.to] && this.imUserProfiles[this.activeAccount.to].custom) {
          let custom = JSON.parse(this.imUserProfiles[this.activeAccount.to].custom)
          if (custom.channel && this.channels[custom.channel]) return '@' + this.channels[custom.channel]
        }
      }
      return ''
    }
  },
  data () {
    return {
      channels: ['', '', '微信企业火小程序', '企业火官网']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/im/right/ImRightContent.vue